import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/** Tracks whether the global search overlay is open, so a trigger in the header
    can open the single overlay instance rendered in the app shell. */
@Injectable({ providedIn: 'root' })
export class SearchService {
  private _open$ = new BehaviorSubject<boolean>(false);
  readonly open$ = this._open$.asObservable();

  open(): void { this._open$.next(true); }
  close(): void { this._open$.next(false); }
  toggle(): void { this._open$.next(!this._open$.value); }
}
